import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipVariations } from '@ktypes/props';
import { UtilsModule } from '@kutil';
import { popperVariation, provideTippyConfig, TippyDirective, tooltipVariation } from '@ngneat/helipopper';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppSwitcherComponent } from './app-switcher/app-switcher.component';
import { InviteComponent } from './invites/invite/invite.component';
import { InviteFilterPipe } from './invites/modal-invite/invite-filter.pipe';
import { ModalInviteComponent } from './invites/modal-invite/modal-invite.component';
import { LabelFlagComponent } from './label-flag/label-flag.component';
import { LiveSupportDetailComponent } from './live-support-detail/live-support-detail.component';
import { ModalComponent } from './modal/modal.component';
import { RichTextComponent } from './rich-text/rich-text.component';
import { VersionExpiredComponent } from './version-expired/version-expired.component';

@NgModule({
  imports: [AngularSvgIconModule.forRoot(), CommonModule, RouterModule, TippyDirective, UtilsModule],
  declarations: [
    AppSwitcherComponent,
    InviteComponent,
    InviteFilterPipe,
    LabelFlagComponent,
    LiveSupportDetailComponent,
    ModalComponent,
    ModalInviteComponent,
    RichTextComponent,
    VersionExpiredComponent,
  ],
  exports: [
    AppSwitcherComponent,
    AngularSvgIconModule,
    InviteComponent,
    InviteFilterPipe,
    LabelFlagComponent,
    LiveSupportDetailComponent,
    ModalComponent,
    ModalInviteComponent,
    RichTextComponent,
    VersionExpiredComponent,
  ],
  providers: [
    provideTippyConfig({
      defaultVariation: 'primary',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
        primary: TooltipVariations.primary,
        primaryInfo: TooltipVariations.primaryInfo,
        challengeMenu: TooltipVariations.challengeMenu,
      },
      popperOptions: {
        strategy: 'fixed',
      },
    }),
  ],
})
export class UiModule {}
